export default __webpack_public_path__ + "static/media/3_3_hl.7de1fd2b.png";